import { useEffect, useState } from "react";

const useRecaptcha = (action: string, refresh: boolean = false) => {
  const siteKey = process.env.REACT_APP_SITE_URL;
  const [recaptchaToken, setRecaptchaToken] = useState("");

  useEffect(() => {
    const loadRecaptcha = () => {
      window.grecaptcha.enterprise.ready(async () => {
        const token = await window.grecaptcha.enterprise.execute(siteKey, {
          action,
        });
        setRecaptchaToken(token);
      });
    };

    if (window.grecaptcha && window.grecaptcha.enterprise) {
      loadRecaptcha();
    } else {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
      script.async = true;
      script.onload = loadRecaptcha;
      document.body.appendChild(script);
    }

    // The effect will re-run whenever the `refresh` or `action` changes
  }, [siteKey, action, refresh]);

  return recaptchaToken;
};

export default useRecaptcha;
